export default {
    routes: [{
        path: '/',
        component: () => import('../pages/Index.vue'),
        name: 'index',
        meta: {
            name: 'Home',
            title: window.titlePrefix
        }
    },
    {
        path: '/about',
        component: () => import('../pages/pages/About.vue'),
        name: 'about',
        meta: {
            name: 'About',
            title: window.titlePrefix
        }
    },
    {
        path: '/contact',
        component: () => import('../pages/pages/Contact.vue'),
        name: 'contact',
        meta: {
            name: 'Contact',
            title: window.titlePrefix
        }
    },
    {
        path: '*',
        component: () => import('../pages/NotFound.vue'),
        name: 'not-found',
        meta: {
            name: 'Not Found',
            title: window.titlePrefix
        }
    }]
};